import { schema } from "normalizr";
import { SchemaSchema } from "./schema";

export const SchemasSchema = new schema.Array(SchemaSchema);
